// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ku5A","field":"styles_field__il5dC","fieldCol":"styles_fieldCol__3bXIS","diffCol":"styles_diffCol__1HN5N","diff":"styles_diff__3iglv"};